import { defineComponent as _defineComponent } from 'vue'
import NewBlogCarousel from 'JS/components/carousels/NewBlogCarousel.vue';
import { BlogCarouselWidgetResource } from '../../types/widgets/blog-carousel-widget';


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogCarouselWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: BlogCarouselWidgetResource;
}



return { __sfc: true,props, NewBlogCarousel }
}

})